import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import { sysLoginOut } from "@/api/api-basic";
import { getBacklogSysDetail } from "@/api/oms-operation-service";
import i18n from "@/config/i18n";
let PiHeader = class PiHeader extends Vue {
    constructor() {
        super(...arguments);
        this.time = "";
        this.navIndex = 1;
        this.msgNum = 0;
        this.userName = { operName: "--", position: "管理员" };
        this.visible = false;
        this.msgTipsList = [
            {
                key: "systemSmsPurchasedRecordAmount",
                name: "待审核短信购买",
                englishName: "SMS review not processed",
                url: "/homepage/message/record?auditStatus=1",
            },
            {
                key: "systemNetSystemAmount",
                name: "待审核互联互通",
                englishName: "Interconnection not handled",
                url: "/homepage/audit-hlht-system?netStatus=0",
            },
            {
                key: "systemSettlementOrderAmount",
                name: "待处理分成账单",
                englishName: "Unprocessed share bill",
                url: "",
            },
        ];
    }
    getIsLogin(val) {
        if (val) {
            this.getBacklogSysDetail();
        }
    }
    getVisible(val) {
        if (val) {
            this.getBacklogSysDetail();
        }
    }
    goOut() {
        this.$Modal.confirm({
            title: i18n.t("tips") + "",
            content: i18n.t("header.outConfirm") + "",
            onOk: () => {
                this.sysLoginOut();
                // this.$Message.info("Clicked ok");
            },
            onCancel: () => {
                // this.$Message.info("Clicked cancel");
            },
        });
    }
    async sysLoginOut() {
        await sysLoginOut({});
        this.$common.out();
    }
    fullScreen() {
        const doc = document;
        const main = doc.body;
        if (this.isFullScreen()) {
            if (doc.exitFullscreen) {
                doc.exitFullscreen();
            }
            else if (doc.mozCancelFullScreen) {
                doc.mozCancelFullScreen();
            }
            else if (doc.webkitCancelFullScreen) {
                doc.webkitCancelFullScreen();
            }
            else if (doc.msExitFullscreen) {
                doc.msExitFullscreen();
            }
        }
        else {
            if (main.requestFullscreen) {
                main.requestFullscreen();
            }
            else if (main.mozRequestFullScreen) {
                main.mozRequestFullScreen();
            }
            else if (main.webkitRequestFullScreen) {
                main.webkitRequestFullScreen();
            }
            else if (main.msRequestFullscreen) {
                main.msRequestFullscreen();
            }
        }
    }
    isFullScreen() {
        const doc = document;
        const win = window;
        return (doc.body.scrollHeight == win.screen.height &&
            doc.body.scrollWidth == win.screen.width);
    }
    async getBacklogSysDetail() {
        const ret = await getBacklogSysDetail({});
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data[0];
            this.msgNum = data.totalAmount || 0;
            for (const i in data) {
                this.msgTipsList.map((item) => {
                    if (i == item.key) {
                        item.value = data[i];
                    }
                });
            }
        }
    }
    mounted() {
        if (this.isLogin) {
            this.getBacklogSysDetail();
        }
        this.time = this.$common.thisTimes("yyyy-MM-dd HH:MM");
    }
};
__decorate([
    Prop({ default: "" })
], PiHeader.prototype, "menuId", void 0);
__decorate([
    Prop({ default: false })
], PiHeader.prototype, "isLogin", void 0);
__decorate([
    State("sys")
], PiHeader.prototype, "sys", void 0);
__decorate([
    Watch("isLogin")
], PiHeader.prototype, "getIsLogin", null);
__decorate([
    Watch("visible")
], PiHeader.prototype, "getVisible", null);
PiHeader = __decorate([
    Component
], PiHeader);
export default PiHeader;
